<template>
  <div>
    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]" />

    <div class="h-piece">
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>订单信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order" class="demo-ruleForm h-formbLine">
              <el-form-item label="订单类型" class="h-elformWrap-2">
                <el-input v-model="xsqyStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="order.cuname" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建时间" class="h-elformWrap-2">
                <el-input v-model="order.cdate" readonly></el-input>
              </el-form-item>
              <el-form-item label="订购原因" prop="businessReason" class="h-elformWrap-2" v-if="showIsFree" :rules="[
							  { required: true, message: '请选择订购原因', trigger: 'change'},
							]">
                <brselect clearable category="business_reason" :v="order.businessReason" v-model="order.businessReason"></brselect>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>客户信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form1" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item prop="soldToName" label="售达方名称" :rules="[
								  { required: true, message: '请输入售达方名称', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                  <i v-if="selectDailishang" class="el-icon-search el-input__icon" slot="suffix" @click="openShoudf">
                  </i>
                </el-input>
              </el-form-item>

              <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[
								  { required: true, message: '请输入客户渠道', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-select v-model="order.customerChannelCode" placeholder="请选择" @change="cleanOrder()" style="width:100%">
                  <el-option v-for="item in customerChannelListFilter" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <!--                            <el-form-item prop="toCompanyname" label="收货单位" :rules="[
								  { required: true, message: '请输入收货单位', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.toCompanyname" placeholder="请输入"></el-input>
                            </el-form-item>-->
              <!--                            <el-form-item prop="toCompanyname" label="收货单位"  class="h-elformWrap-2" :clearable="true">
                                &lt;!&ndash;                                <el-input v-model="order.toCompanyname" placeholder="请输入"></el-input>&ndash;&gt;
                                <el-input v-model="order.toCompanyname"  v-if="order.selectFlag" :v="order.toCompanyname"></el-input>
                                <el-select v-model="order.toCompanyname" style="width:165px" :v="order.toCompanyname" v-if="!order.selectFlag" filterable remote
                                           placeholder="请输入"
                                           :remote-method="showFormList" @change="showForm">
                                    <el-option v-for="(item) in addrList"
                                               :key="item.id"
                                               :label="item.deptName"
                                               :value="item.deptName">
                                    </el-option>
                                </el-select>
                            </el-form-item>-->
              <el-form-item label="收货单位" prop="toCompanyname" class="h-elformWrap-z" :clearable="true" :rules="[
								  { required: true, message: '请选择收货单位', trigger: 'blur'},
								]">
                <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:165px" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                  <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="h-elformWrap-m" :clearable="true">
                <i class="el-icon-circle-plus" @click="createAddress"></i>
              </el-form-item>
              <!--                            <el-form-item prop="collageTypeCode" v-if="this.showCollage" label="细分学院" :rules="[
								  { required: true, message: '请选择细分学院', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <brselect clearable category="collage_type"
                                          :v="order.collageTypeCode"
                                          v-model="order.collageTypeCode"></brselect>
                            </el-form-item>-->
              <el-form-item label="选择收货地址" readonly :rules="[{ required: true, message: '请输入选择收货地址', trigger:['change', ' blur','input']},]" prop="toAddress" class="h-elformWrap-2">
                <el-input clearable v-model="order.toAddress" readonly style="width:100%;">
                  <i class="el-icon-search el-input__icon" slot="suffix" @click="selectAreadialog">
                  </i>
                </el-input>
              </el-form-item>

              <el-form-item prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'blur'},
								]" class="h-elformWrap-2">
                <el-input v-model="order.contactName" placeholder="请输入"></el-input>
              </el-form-item>

              <!--                            <el-form-item prop="toAddress" label="收货地址" :rules="[-->
              <!--								  { required: true, message: '请输入收货地址', trigger: 'blur'},-->
              <!--								]" class="h-elformWrap-2">-->
              <!--                                <el-input v-model="order.toAddress" placeholder="请输入"></el-input>-->
              <!--                            </el-form-item>-->

              <el-form-item label="联系电话" width="300" class="h-elformWrap-2" :rules="[
								  { required: true, message: '请输入联系电话', trigger:['change', ' blur','input']},
								  { required: true, pattern: /^((\d+-\d+?)|(\d+))$/, message: '请输入正确的电话号码', trigger: 'blur' }
								]" prop="firsttelephone">
                <div class="block">
                  <el-input v-model="order.firsttelephone" placeholder="请输入"></el-input>
                </div>
              </el-form-item>

              <el-form-item label="期望收货日期" class="h-elformWrap-2" width="120px" :rules="[
								  { required: true, message: '请先选择收货地址', trigger: 'blur'},
								]" prop="receivedTime">
                <div class="block">
                  <el-date-picker v-model="order.receivedTime" type="date" value-format="yyyy-MM-dd" placeholder="--选择--" :picker-options="{
                                                disabledDate(time) {
                                                  return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
                                                },
                                            }">
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item prop="currencyCode" label="币种" class="h-elformWrap-2">
                <mdmselect clearable category="YLCurrency" :showcode="true" disabled :v="order.currencyCode" v-model="order.currencyCode"></mdmselect>
              </el-form-item>

              <el-form-item label="见证性资料" v-if="this.order.category2Name == '标准服务订单'" class="h-elformWrap-2">
                <brupload v-model="order.sgfileUrl" :refid=testID reftype="JZXZL" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                </brupload>
              </el-form-item>
              <el-form-item v-if="this.zhidanflag&&!guanliren" label="直单附件" class="h-elformWrap-2" required>
                <el-upload style="margin-top: 0;" v-model="order.zmFile" class="upload-demo" action="" :http-request="httpRequest2" :on-remove="handleRemove2" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileList2" :auto-upload=true>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item v-if="this.order.orderCategory2 == '5'" label="附件" class="h-elformWrap-2">
                <brupload v-model="order.scmfFile" :refid=testID reftype="SCMFFW" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                </brupload>
              </el-form-item>
              <el-form-item label="是否协同收入" class="h-elformWrap-2" v-if="!showXietong" required>
                <brselect clearable category="is_xietong" :v="order.isXietong" v-model="order.isXietong"></brselect>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <div class="h-table h-mrt30 ljjtablepaddings11" style="margin: 10px 20px 0 10px;">
        <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
          <h1 class="h1" style="margin-left: 7px;">产品信息</h1>
          <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" @click="showProcuct1" v-if="showaddProductRow">选择产品</el-button>
        </div>
        <div v-for="(obj,index) in companyInfoList" :key="index">
          <div v-if="getProductlist(obj.code).length>0" style="margin-bottom: 20px;">
            <span style="color: #4a4a4a;" v-if="!chooseGscode">{{ obj.name }}</span>
            <el-select v-model="zhidanGsCode" placeholder="请选择" @change="chooseGsCode($event),$forceUpdate()" style="width:320px" v-if="chooseGscode">
              <el-option v-for="item in zhidanCompanycode" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>

            <el-form label-position="right" :inline="true" :ref="'form'+obj.code" :model="order" class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
              <el-form-item label="成本中心" :prop="'costCenter'+obj.code" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;" :rules="[
					  { required: true, message: '请选择成本中心', trigger: 'change'},
					]">
                <el-select v-model="order['costCenter'+obj.code]" style="width: 350px;" clearable filterable placeholder="--选择--">
                  <el-option v-for="item in getCostList(obj.code)" :key="item.index" :label="`${item.costCenterCode} : ${item.remark}`" :value="item.costCenterCode"></el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <el-table ref="multipleTable" :data="getProductlist(obj.code)" stripe border style="width: 100%;margin-top: 20px;">
              <el-table-column type="index" label="#" width="40">
              </el-table-column>
              <el-table-column prop="cpz" label="产品组" :show-overflow-tooltip="true" width="80">
              </el-table-column>
              <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="130">
              </el-table-column>
              <el-table-column prop="materialName" min-width="190" label="产品名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.materialName" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="oemDesc" min-width="190" label="规格型号">
              </el-table-column>
              <el-table-column prop="proNumber" label="订单数量" width="120">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.proNumber" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="proBenchmarkPrice" label="基准价" v-if="agentLevel!=2" width="150">
                <template slot-scope="scope">

                  <div style="text-align: right;">
                    {{scope.row.proBenchmarkPrice}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="taxCode" label="税率" width="150">
                <template slot-scope="scope">
                  <el-select class="h-tableInput" disabled @input="changeTax($event,scope.row)" v-model="scope.row.taxCode" placeholder="请选择">
                    <el-option label="0%" value="J0"></el-option>
                    <el-option label="6%" value="JQ"></el-option>
                    <el-option label="13%" value="JC"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="finalPrice" label="成交价" :show-overflow-tooltip="true" width="150">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{ scope.row.finalPrice = new big(scope.row.proBenchmarkPrice).toFixed(2).toString() }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="jinejjz" label="净价值" :show-overflow-tooltip="true" width="110">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{ scope.row.jinejjz = new
                        big(scope.row.finalPrice||0).div(scope.row.taxRate).toFixed(2).toString()}}</div>
                </template>
              </el-table-column>

              <el-table-column prop="totalprice" label="总价" :show-overflow-tooltip="true" width="150">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice||0)).toString() }}</div>
                </template>
              </el-table-column>

              <el-table-column prop="note1" label="备注" min-width="160">
                <template slot-scope="scope">
                  <el-input class="h-tableInput" v-model="scope.row.note1" placeholder="请输入" auto-complete="off"></el-input>
                </template>
              </el-table-column>

              <el-table-column label="操作" v-if="showdelProductRow" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteThis(scope.row)">
                    删除
                  </el-button>
                  <!-- <div class="l-operationBox">
                            <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                        </div> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="jieguo" v-if="!showIsFree">
              <span class="jieguo_label">订单总价</span>
              <span class="jieguo_value">{{  getOrderName(obj.code).orderPrice }}</span>
              <span v-if="agentLevel!=2" class="jieguo_label">现金余额</span>
              <span v-if="agentLevel!=2" class="jieguo_value">{{ getOrderName(obj.code).xianjye }}</span>
              <span v-if="agentLevel!=2" class="jieguo_label">现金占用</span>
              <span v-if="agentLevel!=2" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXj = new big(getOrderName(obj.code).orderPrice||0).minus(getOrderName(obj.code).orderPriceXd||0).toString() }}</span>
              <span v-if="agentLevel!=2" class="jieguo_label">现金欠款</span>
              <span v-if="agentLevel!=2" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXjQk = new big(getOrderName(obj.code).xianjye||0).minus(getOrderName(obj.code).orderPriceXj||0)>0 ? 0:(new big(getOrderName(obj.code).xianjye||0).minus(getOrderName(obj.code).orderPriceXj||0).abs()) }}</span>
              <span v-if="agentLevel!=2" class="jieguo_label">信贷选择</span>
              <span v-if="agentLevel!=2" class="jieguo_value">
                <el-select v-if="agentLevel!=2" class="ljjsales" v-model="getOrderName(obj.code).creditid" clearable placeholder="请选择" @change="creditChange($event,obj.code)">
                  <el-option v-for="item in getOrderName(obj.code).creditData" :key="item.id" :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`" :value="item.id">
                    <div style="color: #8492a6; font-size: 12px">
                      <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                      <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                    </div>
                  </el-option>
                </el-select>
              </span>
              <span v-if="agentLevel!=2" class="jieguo_label">信贷占用</span>
              <span v-if="agentLevel!=2" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXd }}</span>
              <!--
                    <span class="jieguo_label">净价值</span>
                    <span class="jieguo_value">{{order9390.orderNetWorth}}</span>
                    -->
            </div>

          </div>

        </div>

      </div>
      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->

      <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
      <!--物料-->
      <wxwl :visible.sync="showwuliaodialog1" v-if="showwuliaodialog1" @choseObj="choseWuliao1" :usercode="order.soldToCode" :ddlx="ddlx" :xmcode="xmcode" :currencyCode="order.currencyCode" :fwddlx="fwddlx" :serviceProductsType="serviceProductsType" :customerChannelCode="order.customerChannelCode" title="选择物料" />
      <!-- 套机-->
      <!-- <taoji :visible.sync="showdialog2" v-if="showdialog2" @choseObj="choseTaoji" :usercode="order.soldToCode"
               title="选择物料"></taoji> -->
      <!--售达方-->
      <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag :usercode="currentUser" :xmcode="xmcode" :ordertype="ordertype" title="选择售达方" />
      <!--地址信息-->
      <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />

      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
      <mapShow :visible.sync="mapDialogVisible" v-if="mapDialogVisible" @choseObj="choseMapShow" title="地图选点" style=" margin-top: -15vh" />
    </div>
    <div v-if="taskstatus=='0'">
      <div class="anniu" v-if="!resubmit">
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
        </el-row>
      </div>
      <div class="anniu" v-else>
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
          <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </el-row>
      </div>
    </div>
    <div class="anniu" v-if="taskstatus == '1'">
      <el-row>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="this.$store.dispatch('backToTaskIndex')">返回</el-button>
      </el-row>
    </div>
    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="institutionalX" class="h-dialog2">
      <companyName ref="companyName" :titleName="titleDig" :add1="add" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
    </el-dialog>
    <!--        <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>{{titleDig}}</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
     <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">单位名称为大学时，请按实际情况维护用户分类(211/985)</h6>
                <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                    <el-form-item  label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName">
&lt;!&ndash;                        <el-input v-model="add.deptName" placeholder="请输入单位名称"></el-input>&ndash;&gt;
&lt;!&ndash;                        <img :src="mapSrc" @click="mapHandleShow" title="地图选点[快速录入]" style="cursor: pointer;width: 20px; margin-top: -20px;vertical-align:bottom"/>&ndash;&gt;
                        <el-select v-model="add.deptName"  remote filterable :filter-method="selectDept" clearable placeholder="请输入" allow-create filterable
                                   :remote-method="selectDept" @change="changeDeptName($event)" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
                            <el-option v-for="(item) in deptNameList"
                                       :key="item.deptName"
                                       :label="item.deptName"
                                       :value="item.deptName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
                        <brselect category="sales_region" :v="add.deptSourceChannel" :showcode="true" @change="changeChannel($event)"
                                  v-model="add.deptSourceChannel" clearable></brselect>
                    </el-form-item>
                  <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]">
                    <el-select v-model="add.schoolTypeName"
                               @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                      <el-option v-for="item in addressTypeList"
                                 :key="item.id"
                                 :label="item.userUnit"
                                 :value="item.userUnit">
                      </el-option>
                    </el-select>
                  </el-form-item>
                    <el-form-item label="省" class="h-elformWrap-2" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                        <el-select v-model="add.province" @change="handleItemChange1" placeholder="省" >
                            <el-option
                                    v-for="item in shenglist"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="市" class="h-elformWrap-2" prop="city"
                                  :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                        <el-select v-model="add.city" @change="handleItemChange2"
                                   :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                   placeholder="市">
                            <el-option
                                    v-for="item in arealist2"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区" class="h-elformWrap-2" prop="area"
                                  :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                        <el-select v-model="add.area"
                                   :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                   placeholder="区" @change="handleItemChange3">
                            <el-option
                                    v-for="item in arealist3"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级" class="h-elformWrap-1" label-width="100" prop="deptName">
                        <treeselect
                                :multiple="false"
                                :options="options"
                                :flat="true"
                                :default-expand-level="1"
                                placeholder="请选择"
                                v-model="stVal"
                        />
                        <treeselect-value :value="stVal" />
                    </el-form-item>
                    <el-form-item label="详细地址" class="h-elformWrap-1"
                                  :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                                  prop="address">
                        <el-input v-model="add.address" style="width: 84%;"></el-input>
                    </el-form-item>
                </el-form>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>-->
  </div>
</template>

<script>
import big from 'big.js'
import ss from '../../api/SystemService'
import wxwl from '../../components/dialog/wxwl'
import shoudf from '../../components/dialog/selectshdf'
import taoji from '../../components/dialog/wxwl-fuwu'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import uploadFile from "../../api/process/account_complainUploadService";

import uploaddown from '../../utils/updownfile'
import companyName from "@/components/basic/companyName.vue";
export default {
  components: {
    companyName,
    wxwl, shoudf, taoji, Treeselect
  },
  data () {
    return {
      institutionalX: false,
      submitChongfuFlag: true,
      aflag: false,
      //行项目
      productlist9390: [],
      productlist9370: [],
      productlist1D90: [],
      productlist1JC0: [],
      productlist1RK0: [],
      productlist1R60: [],
      productlist0PN0: [],
      productlist1S00: [],
      productlist1S40: [],
      productlist44U0: [],
      productlist45K0: [],
      allProjectByUser: [],

      costList9390: [],
      costList9370: [],
      costList1D90: [],
      costList1JC0: [],
      costList9391: [],
      costList1RK0: [],
      costList1R60: [],
      costList0PN0: [],
      costList1S00: [],
      costList1S40: [],
      costList44U0: [],
      costList45K0: [],
      showPO: false,
      showdialog2: false,
      productType: "",
      productTypes: [{ value: "单机" }, { value: "套机" }],

      resubmit: false,
      instid: null,
      taskstatus: 0,

      showhistory: false,

      selectDailishang: true,

      showwuliaodialog1: false,
      showwuliaodialog2: false,
      showshdfdialog: false,
      showdizhiflag: false,
      currentUser: null,
      showaddProductRow: true,
      showdelProductRow: true,

      //特价
      tejieshowflag: false,
      //定制展示
      dingzhishowflag: false,

      //现金余额
      cashBalance: 0,

      //展会项目不展示合同号
      contractflag: true,

      xmcode: null,
      ordertype: null,
      ddlx: null,
      fwddlx: null,
      serviceProductsType: null,
      isBlood: 0,
      //是否直单用户
      zhidanflag: 0,
      companycodes: "",
      zhidanCompanycode: [],
      chooseGscode: false,
      zhidanGsCode: "",
      //经销商级别(一级二级)
      agentLevel: "",

      order: {
        id: null, // 主键
        orderMainContract: null, // 主合同编号
        orderSubContract: null, // 分合同编号
        orderProjectCode: null, // 项目编号
        orderProjectName: null, // 项目名称
        orderCategory: null, // 订单类型
        orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
        saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
        disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
        zCode: null, // 分销渠道编码-子编码
        customerChannelCode: null, // 客户渠道
        isStockUp: null, // 是否备货      1：是；0：否
        orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
        instid: null, // 流程id
        taskId: null, // 流程id
        tuihyy: null, // 退货原因
        tuihyydes: null, // 退货原因说明
        contactName: null, // 联系人名称
        receivedTime: null, // 预计收货时间
        soldToCode: null, // 售达方编码
        soldToName: null, // 售达方名称
        soldToAreaCode: null, // 售达方地区编码
        soldToAreaName: null, // 售达方地区名称
        shipToCode: null, // 送达方编码
        shipToName: null, // 送达方名称
        shipToAreaCode: null, // 送达方地区编码
        invoiceCode: null, // 开票方编码
        payerCode: null, // 付款方编码
        currencyCode: null, // 币种编码
        orderPrice: null, // 订单总价
        orderPriceXj: 0, // 订单现金占用
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: null, // 订单净价值
        poId: null, // PO号
        areaId: null, // 区域详情表关联id
        dcCode: null, // 配送中心编码
        toProvincesCode: null, // 送达省份编码
        toCityCode: null, // 送达城市编码
        note: null, // 订单备注
        note1: null, // 产品备注
        postcode: null, // 邮政编码
        firsttelephone: null, // 第一个电话
        secondtelephone: null, // 第二电话
        extraPrice: null, // 定制加价
        customized: null, // 定制需求
        sapsended: null, // 是否已提交sap,1-是,0-否
        toAddress: null, // 收货地址
        toCompanyname: null, // 送达方公司全称
        posnr: null, // 外销:销售和分销凭证的项目号
        inco1: null, // 外销:国际贸易条款 (部分1)
        inco2: null, // 外销:国际贸易条款 (部分2)
        submitflag: null,//提交标志
        categoryName: null,
        category1Name: null,
        category2Name: null,
        saleGrputName: null,
        disChannelName: null,
        zcodeName: null,
        expoPrice: null,//展会价
        fktj: null, //付款条件
        sgfileUrl: [],
        selectFlag: false,
        agentLevel: "",
        zmFile: null,
        scmfFile: null,
        upload2: [],
        collageTypeCode: null,
        businessReason: null,//订购原因

        costCenter9390: null,
        costCenter9370: null,
        costCenter1D90: null,
        costCenter1JC0: null,
        costCenter1RK0: null,
        costCenter1R60: null,
        costCenter9391: null,
        costCenter0PN0: null,
        costCenter1S00: null,
        costCenter1S40: null,
        costCenter44U0: null,
        costCenter45K0: null,
        isXietong: 0, // 是否协同收入
      },

      //产品list
      productlist1: [],
      addrList: [],
      order9390: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9370: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1D90: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1JC0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1RK0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1R60: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order0PN0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S00: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S40: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order44U0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order45K0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      //用户信贷list
      creditData: [],
      testID: '',

      newDialog: false,
      titleDig: false,
      shenglist: [],
      arealist2: [],
      arealist3: [],
      add: {
        id: '',
        deptName: '',
        deptType: '',
        leader: '',
        phone: '',
        email: '',
        status: '',
        countryId: '',
        country: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        landmark: '',
        area: '',
        address: '',
        shengobj: '',
        shiobj: '',
        quobj: '',
        selectId: '',
        address: '',
        subFlag: '',
        deptSourceChannel: '',
        longitude: '',
        latitude: '',
        parentCode: '',
        schoolTypeName: '',
      },
      proSelect: {
        pcode: 0,
        level: 1,
      },
      mapDialogVisible: false,
      deptNameList: [],
      addressTypeList: [],
      options: [],
      stVal: null,
      fileList2: [],
      idList: [],
      reftype2: 'NX_ZMFJ',
      showCollage: false,
      showIsFree: false,
      customerChannelListFilter: [],
      //所用公司信息
      companyInfoList: [],
      guanliren: false,
      showXietong: false,
    }
  },
  //页面加载前事件
  created () {
    //所用公司信息
    this.companyInfoList = this.$store.getters.dictlist("company_info");
    // 当前权限
    this.guanliren = this.$store.getters.hasRole("swyl_xiaoshoujl_yx,yx_shouhoujl");
    //是否协同收入
    this.showXietong = this.$store.getters.hasRole("swyl_gndailishang,swyl_gwdailishang,swyl_xiaoshoujl,swyl_xiaoshoujl_wx,swyl_dingdgly,swyl_waixiaogly");
    //生产所有公司产品变量
    this.companyInfoList.forEach((obj) => {
      //动态生成监听
      this.$watch('productlist' + obj.code, (newValue, oldValue) => {

        //计算总金额
        this['order' + obj.code].orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //计算总净价值
        this['order' + obj.code].orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //重新计算信贷
        if (this['order' + obj.code].creditid) {
          this.creditChange(this['order' + obj.code].creditid, obj.code);
        }
      }, { deep: true, immediate: true });

    })

    this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
    this.customerChannelList = this.$store.getters.dictlist("sales_region");
    let id = this.$route.query.ywid;
    let instid = this.$route.query.instid;
    let taskid = this.$route.query.taskid;
    let taskstatus = this.$route.query.taskstatus | 0;

    //代办打开的
    if (id && instid) {
      this.resubmit = true;
      //不能添加跟删除了
      this.showaddProductRow = false;
      this.showdelProductRow = false;

      this.instid = instid;
      this.taskstatus = taskstatus;
      this.order.taskId = taskid;
      if (taskstatus == '1') {
        // 直接设置经销商
        this.selectDailishang = false;
        const parent = document.querySelector(".input");
        parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
        //2.在设置input属性
        //获取input
        const input = document.querySelector(".input input");
        //设置input的属性为false
        input.disabled = false;
      }
    }


    if (this.$route.query.agentLevel == 2) {
      this.getSecondOrder(id || this.$route.query.id);
    } else {
      this.getOrder(id || this.$route.query.id);
    }


    if (this.$route.query.id == '' || this.$route.query.id == undefined) {
      this.testID = this.$route.query.ywid
    } else {
      this.testID = this.$route.query.id
    }
    this.getParentInfo();
  },
  mounted () {

  },
  computed: {
    xsqyStr () {
      if (this.order.category1Name) {
        return this.order.categoryName + "/" + this.order.category1Name + "/" + this.order.category2Name
      }
      return this.order.categoryName
    },
  },
  watch: {
    //原逻辑删除mark
  },
  methods: {
    changeTax (data, row) {
      if (data == "J0") {
        row.taxRate = "1";
      } else if (data == "JQ") {
        row.taxRate = "1.06";
      } else if (data == "JC") {
        row.taxRate = "1.13";
      }
    },
    //特价改变
    changeTejia (scode, row) {
      console.log('特价改变', scode, row)
      if (row.specialOfferCode) {
        const tjobj = _.find(row.tjlist3Q, { tjdtid: row.specialOfferCode })
        row.specialPrice = tjobj.tejia;
        row.specialPriceNum = tjobj.sysl;
        row.tjid = tjobj.tjid;
        row.tjdtid = tjobj.tjdtid;
        row.finalPrice = tjobj.tejia;
        row.proBenchmarkPrice = tjobj.dingjia;//产品基准价
      } else {
        row.specialOfferCode = null;
        row.specialPrice = null;
        row.specialPriceNum = null;
        row.tjid = null;
        row.tjdtid = null;
        row.proBenchmarkPrice = 0;//产品基准价
      }
    },
    choseTaoji (attr) {

      var list = attr[0].componentList;
      for (var i = 0; i < list.length; i++) {
        var obj = list[i];
        var wl = this.wlToProject(obj);

        if (this.productlist1.length != 0) {
          var headobj = _.head(this.productlist1)
          //不存在，是一个新的产品型号编码
          if (headobj.proModelCode != wl.proModelCode) {
            this.$msg.msge("只能选择同一种产品大类型号！");
            this.showwuliaodialog1 = false;
            return false;
          }
          //不存在，是一个新的产品型号编码
          if (headobj.currencyCode != wl.currencyCode) {
            this.$msg.msge("只能选择同一种产品大类型号！");
            this.showwuliaodialog1 = false;
            return false;
          }
        }
        //添加行项目
        this.addProject(wl)
        // this.currency = obj.currency;
        // var data = {
        // 	id:this.$util.getUuid(),
        // 	materialCode:obj.matecode,
        // 	proModelCode:obj.matedes,
        // 	proBenchmarkPrice:obj.jizhj,
        // 	totalPrice:0
        // }
        // this.productlist1.push(data);
      }
      this.showdialog2 = false;
    },
    getProjectInfo (x) {
      this.allProjectByUser.forEach((item, index) => {
        if (item.id == x) {
          this.tableData.projectName = item.projectName;
          this.tableData.orderData.poId = item.poId;
        }
      })
    },
    getOrder (id) {
      ss.OrderMainService.selectById(id).then(rd => {
        _.assign(this.order, rd.obj)

        let type = this.order.orderCategory1;
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
        this.fwddlx = this.order.orderCategory2 || '1';
        if (this.fwddlx == '4') {
          this.serviceProductsType = '3Q服务类'
        }
        if (this.order.orderCategory2 == '5') {
          this.showIsFree = true;
          //获取成本中心
          Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {

            this.companyInfoList.forEach((obj) => {
              ss.OrderMainService.getCostCenterList({ companyCode: obj.code }).then(rd => {
                this['costList' + obj.code] = rd;
              })
            });
          })
        }



        this.order.soldToAreaName = this.$store.getters.dictname("YLRegion", this.order.soldToAreaCode);
        //存在行项目
        if (rd.obj.products && rd.obj.products.length > 0) {
          //加载完现金跟信贷，在插入行项目
          Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
            rd.obj.products.forEach((obj) => {
              if (obj) {
                this.addProject(obj)
              }
            })
          })
        }
        // this.order.soldToCode="8800219885"
        if (this._user.usertype == '1') {
          this.order.soldToCode = this._user.usercode;
          this.selectDailishang = false;
        }
        // 判断是否是经销商,经销商自己下单
        if (this.order.soldToCode) {
          ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rt => {
            this.choseshoudf(rt, true);
            if (rd.obj.products && rd.obj.products.length > 0) {
              rd.obj.products.forEach((obj) => {
                console.log("123333333333333", rt)
                if (rt.zhidanflag == '1') {
                  uploaddown.listdownfile({ refid: obj.id, reftype: "NX_ZMFJ" }).then(rd => {
                    this.fileList2 = rd.obj;
                    this.idList.push(rd.obj.id);
                    this.order.upload2.unshift("1");
                    if (this.fileList2 == null || this.fileList2.length == 0) {
                      uploaddown.listdownfile({ refid: obj.orderId, reftype: "NX_ZMFJ" }).then(rd => {
                        this.fileList2 = rd.obj;
                        this.idList.push(rd.obj.orderId);
                        this.order.upload2.unshift("1");
                      })
                    }
                  })
                }
              })
            }
          })
        }
        //已有经销商
        // if(this.order.soldToCode){
        //     //现金余额
        //     this.queryMoney()
        //     // 查询信贷
        //     this.getCredit();
        // }

      })
    },

    getSecondOrder (id) {
      ss.SecondOrderMainService.selectSecondOrderById(id).then(rd => {
        _.assign(this.order, rd.obj)

        let type = this.order.orderCategory1;
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
        this.fwddlx = this.order.orderCategory2 || '1';
        if (this.fwddlx == '4') {
          this.serviceProductsType = '3Q服务类'
        }

        this.order.soldToAreaName = this.$store.getters.dictname("YLRegion", this.order.soldToAreaCode);
        //存在行项目
        if (rd.obj.products && rd.obj.products.length > 0) {
          //加载完现金跟信贷，在插入行项目
          rd.obj.products.forEach((obj) => {
            if (obj) {
              this.addProject(obj)
            }
          })

        }
        // this.order.soldToCode="8800219885"
        if (this._user.usertype == '1') {
          this.order.soldToCode = this._user.usercode;
          this.selectDailishang = false;
        }
        // 判断是否是经销商,经销商自己下单
        if (this.order.soldToCode) {
          ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
            this.choseshoudf(rd, true);
          })
        }


      })
    },



    viewpress (r) {
      this.showhistory = true;
    },
    backtolist () {
      this.$router.go(-1);
    },
    saveOrSubmit (v) {
      this.order.orderStatus = v
      if (v == '10') {
        this.order.submitflag = '暂存'
      } else if (v == '20') {
        this.order.submitflag = '提交'
      }
      //每次提交或者暂存将值清零 防止累加 hyl
      this.order.orderPrice = 0;
      this.order.orderPriceRbm = 0;

      if (this.zhidanflag == '1') {
        if (this.fileList2.length < 1) {
          this.$msg.msge("直单用户下单必须上传直单附件！");
          return;
        }
      }

      this.companyInfoList.forEach((obj) => {
        _.forEach(this['productlist' + obj.code], (value) => {
          value.xdid = this['order' + obj.code].creditid
          value.totalpricermb = value.totalprice;
          value.costCenter = this.order['costCenter' + obj.code];
          this.order.orderPrice = new big(this.order.orderPrice || 0).plus(value.totalprice || 0);
          this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);
        });
      })

      //计算所有订单现金占用
      this.order.orderPriceXj = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderPriceXj || 0)).toString();
      }, 0)
      //计算所有订单信贷占用
      this.order.orderPriceXd = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderPriceXd || 0)).toString();
      }, 0)
      this.order.orderNetWorth = new big(this.order.orderPrice).div(1.3).toFixed(2)

      //并所有订单list
      this.order.products = [];
      this.companyInfoList.forEach((obj) => {
        this.order.products = this.order.products.concat(this['productlist' + obj.code]);
      })

      if (this.order.submitflag == '提交') {
        var freeflag = true;
        var companyFlag = true;
        if (this.showIsFree) {
          this.$refs['form0'].validate((valid0) => {
            freeflag = valid0;
          });

          //校验是否选择成本中心
          this.companyInfoList.forEach((obj) => {
            if (this['productlist' + obj.code].length > 0) {
              this.$refs['form' + obj.code][0].validate((valid0) => {
                if (!valid0) {
                  companyFlag = valid0;
                  return false;
                }
              });
            }
          })
          //原逻辑删除mark

        }
        this.$refs['form1'].validate((valid1) => {
          if (valid1 && freeflag && companyFlag) {
            this.$msg.confirm("确认提交？", () => {
              this.submitForm();
            })
          } else {
            this.$msg.msge("请完善基本信息后提交");
            return;
          }
        });

      } else {
        this.submitForm();
      }
    },
    submitForm () {
      if (this.submitChongfuFlag) {
        this.submitChongfuFlag = false;
        ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
          this.submitChongfuFlag = true;
          if (rd.f) {
            if (this.order.submitflag == '提交') {
              this.$msg.msgs("提交成功！")
              //二级经销商订单条二级经销商页面
              if (this.agentLevel == 2) {
                this.$router.push({ path: '/dingd/secondDingdmainlist' })
              } else {
                this.$router.push({ path: '/dingd/dingdmainlist' })
              }

            } else {
              this.$msg.msgs("暂存成功！")
            }
          } else {
            this.$msg.msge(rd.msg);
          }
        })
      } else {
        this.$msg.msge("重复点击提交，请稍后操作！");
      }
    },
    resaveOrSubmit (v) {
      this.order.orderStatus = v

      //每次提交或者暂存将值清零 防止累加 hyl
      this.order.orderPrice = 0;
      this.order.orderPriceRbm = 0;
      this.companyInfoList.forEach((obj) => {
        _.forEach(this['productlist' + obj.code], (value) => {
          value.xdid = this['order' + obj.code].creditid
          value.totalpricermb = value.totalprice;
          value.costCenter = this.order['costCenter' + obj.code];
          this.order.orderPrice = new big(this.order.orderPrice || 0).plus(value.totalprice || 0);
          this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);
        });
      })

      this.$msg.confirm("确认提交？", () => {
        this.order.submitflag = '重新提报'
        ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
          //二级经销商订单条二级经销商页面
          if (this.agentLevel == 2) {
            this.$router.push({ path: '/dingd/secondDingdmainlist' })
          } else {
            this.$router.push({ path: '/dingd/dingdmainlist' })
          }


        })
      })
    },
    //查询用户所有信贷
    getCredit (gscode) {
      var params = {};
      //列表中的第一个的产品大类
      var cpdl = _.uniq(_.map(this['productlist' + gscode], "proModelCode"));
      if (cpdl.length == 1) {
        params.cpdlcode = cpdl[0];
      }
      params.salegroupcode = gscode;
      params.usercode = this.order.soldToCode;
      return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
        console.log(rd)
        this['order' + gscode].creditData = rd.xd;
        this['order' + gscode].xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
      })
    }
    ,
    // 选择具体的信贷
    creditChange (v, gscode) {
      if (v) {
        var xd = _.find(this['order' + gscode].creditData, { id: v })
        //现金，大于订单总额
        if (xd.quota >= this['order' + gscode].orderPrice) {
          this['order' + gscode].orderPriceXd = this['order' + gscode].orderPrice;
        } else {
          //订单减掉现金余额
          this['order' + gscode].orderPriceXd = xd.quota;
        }
      } else {
        this['order' + gscode].creditid = null;
        this['order' + gscode].orderPriceXd = 0;
      }
    },
    //清空已选产品列表
    cleanOrder () {
      console.log('客户渠道发生变化!')
      if (this.ddlx == '1,4') {
        return;
      }
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })

      this.productlist2 = [];
      if (this.showJzx) {
        //如果租赁合同中只包含一个产品，则直接带出 wxwl
        let proList = {};
        if (this.contract.zlList) {
          var list = this.contract.zlList;
          //根据产品编码去重
          list = list.reduce((total, currentValue) => {
            proList[currentValue.productCode] ? '' : proList[currentValue.productCode] = total.push(currentValue);
            return total
          }, [])
          if (list.length == 1) {
            var data = {};
            var proData = {};
            data.usercode = this.order.soldToCode;
            data.ddlx = this.ddlx;
            data.xmcode = this.order.orderMainContract;
            data.currencyCode = this.order.currencyCode;
            data.customerChannelCode = this.order.customerChannelCode;
            data.wlcodename = list[0].productCode;
            ss.wuliaoselect.selectPage(data).then(rd => {
              proData = rd.records;
              this.choseWuliao1(proData);
            })
          }
        }
      }
    },
    //选择售达方
    openShoudf () {
      this.showshdfdialog = true;
    },
    choseshoudf (obj, changeflag) {
      console.log("选择的售达方：", obj);
      //直单用户flag
      this.zhidanflag = obj.zhidanflag;
      this.companycodes = obj.companycodeBas;
      //是否直单用户根据签约的公司进行选择
      this.zhidanCompanycode = [];
      this.zhidanGsCode = '';
      if (this.zhidanflag == '1') {
        this.chooseGscode = true;

        //判断当前用户可选择的公司
        this.companyInfoList.forEach((obj) => {
          if (this.companycodes.indexOf(obj.code) != -1) {
            this.zhidanCompanycode.push({
              key: obj.code,
              value: obj.name
            });
            this.zhidanGsCode = obj.code
          }
        })

        //0HL0 特殊处理
        if (this.companycodes.indexOf("0HL0") != -1) {
          this.zhidanCompanycode.push({
            key: "9370",
            value: "青岛海尔生物医疗科技有限公司(9370)"
          });
          this.zhidanGsCode = '9370'
        }


        //如果都没签约9370或9390 提示错误
        if (this.companycodes.length <= 0) {
          this.showshdfdialog = false
          this.$msg.msge("该直单用户没有签约公司，请联系管理员！")
          return;
        }

      } else {
        this.chooseGscode = false;
      }

      //                设置客户渠道，
      this.customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
        return _.split(obj.khqd3 || '', ",").includes(o.code);
      });
      if (this.customerChannelListFilter.length > 0) {
        this.order.customerChannelCode = this.customerChannelListFilter[0].code;
      } else {
        this.showshdfdialog = false
        this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
        return;
      }
      // 清空物料
      if (this.order.soldToCode != obj.usercode) {
        console.log("为什么不一样：", this.order.soldToCode, obj.usercode)
        this.productlist1 = [];
        this.productlist2 = [];
      }
      this.order.soldToName = obj.username;
      this.order.soldToCode = obj.usercode;
      this.order.soldToAreaCode = obj.area;
      this.order.soldToAreaName = obj.areaname;
      this.order.salesregion = obj.salesregion;
      this.order.salesregionName = obj.salesregionName;
      this.order.gjmytk = obj.gjmytk; //国际贸易条款
      this.order.fktj = obj.fktj; //付款条件
      this.order.currencyCode = changeflag ? this.order.currencyCode : obj.currency;
      this.showshdfdialog = false;
      if (obj.usercode.substring(0, 1) == "A" || obj.usercode.substring(0, 1) == "a") {
        this.aflag = true;
      } else {
        this.aflag = false;
      }
      this.companycodes = obj.companycodeBas;
      this.isBlood = obj.isBlood;
      //设置经销商级别
      this.agentLevel = obj.agentLevel;
      this.order.agentLevel = obj.agentLevel;
    },

    //删除该行项目产品信息
    deleteThis (row) {
      var id = row.id;
      var gscode = row.gscode;
      this.$msg.confirm("确认删除？", () => {
        this['productlist' + gscode] = _.reject(this['productlist' + gscode], { 'id': id });
      })
    },

    //选择物料
    //选择物料
    showProcuct1 () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      this.showwuliaodialog1 = true;
    },
    //选择物料
    choseWuliao1 (objs) {
      for (var i = 0; i < objs.length; i++) {
        var wl = this.wlToProject(objs[i]);
        this.addProject(wl)
      }
      //加载现金跟信贷
      this.companyInfoList.forEach((obj) => {
        this.getCredit(obj.code);
      })

      this.showwuliaodialog1 = false;
    },
    addProject (obj) {
      //签约9370公司并且是血站专用渠道，全部下到9370
      /* if(this.isBlood == '1'){
           obj.gscode = "9370";
       }*/
      //直单用户的话 只能选择签约的公司（9390或9370）
      if (this.zhidanflag == '1') {
        if (this.zhidanGsCode == '') {
          this.$msg.msge("该直单用户没有签约公司，请联系管理员！");
          return;
        } else {
          //根据用户选择公司编码 hyl
          obj.gscode = this.zhidanGsCode;
        }

      }


      this['productlist' + obj.gscode].push(obj);
      this['order' + obj.gscode].creditid = obj.xdid;

      if (!this.order['costCenter' + obj.gscode]) {
        this.order['costCenter' + obj.gscode] = obj.costCenter || null;
      }
    },
    wlToProject (obj) {
      console.log("选中的物料", obj)
      var wl = {};
      wl.id = this.$util.getUuid();
      wl.materialCode = obj.matecode;//物料编码
      wl.materialName = obj.matedes;//物料名称
      wl.proModelCode = obj.cpdlcode;//产品型号编码
      wl.proModelName = obj.cpdlname;//产品型号名称
      wl.cpz = obj.cpz; //产品组
      wl.dwcode = obj.dwcode;//单位
      wl.dwname = obj.dwname;//单位
      wl.proNumber = 0;//产品数量
      wl.proBenchmarkPrice = obj.jizhj;//产品基准价
      wl.feeyongj = 0;//佣金
      wl.currencyCode = obj.currency;//币种编码
      wl.specialOfferCode = null; // 特价版本
      wl.specialPrice = null; // 特价价格
      wl.specialPriceNum = null; // 特价价格
      wl.isCustommed = 0; // 是否定制     1：是   0 否
      wl.extraPrice = null; // 定制加价
      wl.extraDes = null; // 定制需求
      if (obj.factory && obj.factory == '1N60') {
        if (this.chooseGscode) {
          //直单用户自己选
          wl.gscode = obj.companycode; //公司编码
        } else {
          wl.gscode = "1RK0"; //公司编码
        }
        wl.factory = obj.factory;
      } else {
        wl.gscode = obj.companycode; //公司编码
      }
      // wl.gscode=obj.companycode; //公司编码
      if (obj.protype == 'OEM') {
        wl.proType = 'OEM';
        wl.factory = obj.factory;
      } else {
        wl.proType = '自产';
      }
      //2021.1.28成交价默认显示成本价
      wl.finalPrice = obj.jizhj;//成交价
      wl.totalprice = 0;//产品总价
      wl.tjlist3Q = obj.tjlist3Q;
      if (wl.tjlist3Q != null && wl.tjlist3Q.length > 0) {
        this.tejieshowflag = true;
      }
      wl.expoPrice = obj.zhanhj;
      if (obj.taxCat == '3') {
        wl.taxCode = 'JC';
      } else if (obj.taxCat == '7') {
        wl.taxCode = 'JQ';
      } else if (obj.taxCat == '0') {
        wl.taxCode = 'J0';
      } else if (obj.taxCat == '6') {
        wl.taxCode = 'J5';
      }
      //税率
      if (obj.taxCat == '2' || obj.taxCat == '3' || obj.taxCat == '4') {
        wl.taxRate = 1.13;
      } else if (obj.taxCat == '7') {
        wl.taxRate = 1.06;
      } else {
        wl.taxRate = 1;
      }
      /*  wl.taxCode = "JQ";
        wl.taxRate = "1.06";*/
      wl.havePrice = obj.havePrice;
      //如果是二级经销商 基准价*1.07  hyl
      if (this.agentLevel == 2) {
        wl.proBenchmarkPrice = new big(wl.proBenchmarkPrice).times(1.07).toFixed(2).toString()
        wl.finalPrice = wl.proBenchmarkPrice;
      }

      wl.xiaoe = obj.xiaoe;
      wl.jishu = obj.jishu;
      wl.lianqun = obj.lianqun;
      wl.oemDesc = obj.oemDesc;

      return wl;
    },

    //选择地址
    selectAreadialog () {
      this.showdizhiflag = true;
    },
    choseDizhi (obj) {
      this.order.addressCode = obj.id;
      this.order.areaId = obj.id;
      this.order.toAddress = obj.quobj.namepath;
      if (obj.zhenobj) {
        this.order.toAddress = obj.zhenobj.namepath;
      }
      this.order.toAddress = this.order.toAddress + "##" + obj.addrdetail

      this.order.toProvincesCode = obj.shengobj.code;
      this.order.toProvincesName = obj.shengobj.name;

      this.order.toCityCode = obj.shiobj.code;
      this.order.toCityName = obj.shiobj.name;

      this.showdizhiflag = false;
    },
    sgIsUpload (v) {
      console.log('sgIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.sgfileUrl = arrnew
        console.log(this.order.sgfileUrl)
      } else {
        this.order.sgfileUrl = []
      }
    },
    scmfIsUpload (v) {
      console.log('sgIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.sgfileUrl = arrnew
        console.log(this.order.sgfileUrl)
      } else {
        this.order.sgfileUrl = []
      }
    },
    //直单用户修改公司 hyl
    chooseGsCode (code) {

      //将其他公司的数据赋值给选择的公司
      this.companyInfoList.forEach((obj) => {
        if (obj.code != code) {
          this['productlist' + obj.code].forEach((obj) => {
            this['productlist' + code].push(obj);
          })
          //清空其他公司信息
          this['productlist' + obj.code] = [];
        }
      })
      //将所有物料的公司编码改成选择的
      for (var i = 0; i < this['productlist' + code].length; i++) {
        this['productlist' + code][i].gscode = code;
      }

    },
    //获取收货单位
    showFormList (value) {
      // console.log("value188776676","111111111111111111111111")
      var data = value;
      console.log("value188776676", data)
      ss.OrderMainService.getCompanyInfo(value).then(rd => {
        this.addrList = rd;
      })
    },
    //新增收货单位
    createAddress () {
      this.titleDig = "新建收货单位"
      this.institutionalX = true
      /*this.loadArea();*/
    },
    closeCompanyName (propData) {
      console.log(propData);
      this.closeDialog();
    },
    loadArea (i) {
      ss.Dictservice.arealist(this.proSelect).then(rd => {
        this.shenglist = rd;
        // for(let i = 0; i < this.shenglist.length; i++){
        //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
        // }
        console.log("shenglist", this.shenglist)
      })
    },
    //取消
    exit () {
      this.closeDialog()
    },
    //关闭弹窗,清空数据
    closeDialog () {
      this.institutionalX = false
      this.newDialog = false
      this.updateDialog = false
      this.insertFlag = false
      this.reFlag = false
      //清空数据
      this.add.deptName = '';
      this.add.deptType = '';
      this.add.phone = '';
      this.add.leader = '';
      this.add.email = '';
      this.add.province = '';
      this.add.provinceId = '';
      this.add.city = '';
      this.add.cityId = '';
      this.add.area = '';
      this.add.areaId = '';
      this.add.landmark = '';
      this.add.address = '';
      this.add.parentCode = '';
      this.stVal = null;
      this.add.deptSourceChannel = '';
      this.add.schoolTypeName = '';
    },
    //省份选择器
    handleItemChange1 (o) {
      this.add.provinceId = o;
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        console.log("rddddddd", rd.zlist)
        this.add.city = '';
        this.add.area = '';
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
      })
    },
    handleItemChange2 (o) {
      this.add.cityId = o;
      this.address = _.find(this.arealist2, { code: this.add.cityId });
      this.add.city = this.address.name;
      this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      console.log("arealist3", this.arealist3)
      this.arealist4 = []
    },
    handleItemChange3 (o) {
      this.add.areaId = o;
      this.address = _.find(this.arealist3, { code: this.add.areaId });
      this.add.area = this.address.name;
    },
    commitCreate (v) {
      this.add.subFlag = '提交';
      this.add.countryId = '156';
      this.add.country = '中国';
      this.add.provinceId = this.add.provinceId.substring(0, 6);
      this.add.cityId = this.add.cityId.substring(0, 6);
      this.add.areaId = this.add.areaId.substring(0, 6);

      var data = this.add;
      console.log("address", data)
      ss.nxAddress.insertAddress(data).then(rd => {
        this.closeDialog();
        this.query();
      })
    },
    // 地图选点 弹出
    mapHandleShow () {
      this.mapDialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs.mapSrcVue.init(id)
      // })
    },
    choseMapShow (objs) {
      this.add.address = objs.address;
      this.add.deptName = objs.title;
      this.add.province = objs.province;
      this.add.city = objs.city;
      this.add.area = objs.district;
      this.add.longitude = objs.lng;
      this.add.latitude = objs.lat;
      this.loadArea();
      this.mapDialogVisible = false;
    },
    //获取单位名称信息
    selectDept (value) {
      ss.nxAddress.getDeptList(value).then(rd => {
        this.deptNameList = rd.msg;
      })
    },
    //获取当前登录人创建的所有父级单位
    getParentInfo () {
      ss.nxAddress.getParentInfo().then(rd => {
        this.options = rd.msg;
      })
    },
    httpRequest2 (params) {
      console.log(params, "1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.testID, reftype: this.reftype2 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileList2.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.order.upload2.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileList2.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    handleRemove2 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileList2.length; i++) {
        if (this.fileList2[i].id === id) {
          this.fileList2.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    beforeRemove (file) {
      if (file && file.status === "success") {
        return this.$confirm(`确定移除 ${file.name}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      }
    },
    beforeUpload (file) {
      const isFile = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG格式!');
        return false;
      }
    },
    getSchoolType () {
      for (var i = 0; i < this.addrList.length; i++) {
        var address = this.addrList[i];
        if (address.deptName == this.order.toCompanyname) {
          if (address.schoolTypeName != null && address.schoolTypeName != '') {
            this.showCollage = true;
          }
        }
      }
    },
    getShoudafang (usercode) {
      if (!usercode) {
        return "";
      }
      return ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
        this.choseshoudf(rd, true);
      })
    },
    //渠道改变
    changeChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value.code).then(rd => {
        this.addressTypeList = rd.msg;
        this.add.schoolTypeName = '';
      })
    },
    changeSchoolType (value) {
      this.add.schoolTypeName = value;
    },
    //根据公司编码返回productlist
    getProductlist (code) {
      console.log("productlist" + code, this[`${'productlist' + code}`].length)
      return this['productlist' + code];
    },
    //根据公司编码返回OrderName
    getOrderName (code) {
      return this['order' + code];
    },
    //根据公司编码返回costList
    getCostList (code) {
      return this['costList' + code];
    },
    changeDeptName (val) {
      console.log("changeDeptName", val)
      //匹配省市区信息
      ss.nxAddress.getAddressByWl(val).then(rd => {
        if (rd.f == true) {
          this.add.provinceId = rd.msg.provinceId;
          this.add.province = rd.msg.province;
          this.add.cityId = rd.msg.cityId;
          this.add.city = rd.msg.city;
          this.add.areaId = rd.msg.areaId;
          this.add.area = rd.msg.area;
          this.add.address = rd.msg.address;
          this.handleItemChangeN(this.add.provinceId);
        }
      })
      //根据单位名称获取关键字
      ss.nxAddressKeywords.matchKeywords(val).then(rd => {
        if (rd.msg != null) {
          this.add.deptSourceChannel = rd.msg.channelCode;
          this.add.schoolTypeName = rd.msg.userUnit;
          this.matchChannel(rd.msg.channelCode)
        }
      })
    },
    matchChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value).then(rd => {
        this.addressTypeList = rd.msg;
        // this.add.schoolTypeName = '';
      })
    },
    //地址选择器-新
    handleItemChangeN (o) {
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      // this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
        this.address = _.find(this.arealist2, { code: this.add.cityId });
        // this.add.city = this.address.name;
        this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      })
    }
  }
}

</script>


<style scoped>
.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}
.jieguo .jieguo_label {
  width: 2rem;
  text-align: right;
  background-color: #ebf5ff;
  font-size: 12px;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.05rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.jieguo .jieguo_value {
  width: 20%;
  font-size: 15px;
  color: #616467;
  padding: 0px 8px;
  height: 0.4rem;
  line-height: 0.4rem;
}
.queren {
  background-color: #006aca;
  color: white;
}

.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.zancun {
  background-color: #24b5b8;
  color: white;
}

.quxiao,
.zancun {
  width: 100px;
}

.make {
  padding-left: 17px;
}

.zhangqi {
  width: 80px;
  padding-left: 10px;
}

.yuan,
.zhanyong,
.xianjin,
.money,
.dingdan,
.bizhong,
.jiazhi,
.renminbi {
  width: 82px;
  padding-left: 20px;
}

/* .renminbi {
        width: 80px;
        padding-left: 20px;
    } */

.renminbi,
.money,
.yuan,
.zhangqi,
.make {
  background-color: white;
  font-size: 10px;
}

.bizhong,
.dingdan,
.xianjin,
.zhanyong,
.jiazhi {
  background-color: #ebf5ff;
  font-size: 15px;
  padding-left: 20px;
}

.bizhong,
.renminbi,
.dingdan,
.money,
.xianjin,
.yuan,
.zhangqi,
.zhanyong,
.jiazhi,
.make {
  font-size: 15px;
  color: black;
  padding: 20px 0;
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}

img {
  width: 25px;
  padding: 5px 0;
  margin-left: 8rem;
}

.newProject {
  margin: 0 20px;
  background-color: rgb(94, 182, 233);
}

/* .h-crumbOut {
        margin-bottom: 20px;
    } */

.h-piece {
  margin: 20px;
}

.h1 {
  margin-left: 27px;
}

.DshuR {
  width: 100%;
  height: 100%;
  border: none;
}

.message {
  padding: 20px 0;
  margin-bottom: 0;
  background-color: white;
}

.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}

.n-xiao .h-formbLine .h-elformWrap-z,
.n-two .h-formbLine .h-elformWrap-z {
  width: 29%;
}
.n-xiao .h-formbLine .h-elformWrap-m,
.n-two .h-formbLine .h-elformWrap-m {
  width: 2%;
}

.el-cascader {
  line-height: normal;
}
</style>
<style>
.n-two .h-formbLine .el-form-item__content .el-select,
.n-two .el-form .h-formbLine .el-form-item__content .el-select {
  width: 0;
}

.n-xiao .h-formbLine .el-form-item__label,
.n-two .h-formbLine .el-form-item__label {
  width: 43%;
}

.n-xiao .h-formbLine .el-form-item__content,
.n-two .h-formbLine .el-form-item__content {
  width: 57%;
}
.ljjtablepaddings11 .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}
.ljjtablepaddings11 .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}
.ljjtablepaddings11 .ljjsales .el-input__inner {
  height: 0.3rem;
}
.ljjtablepaddings11 .ljjsales .el-input__icon {
  line-height: 0.42rem;
}

/* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
</style>

<style scoped lang="scss">
.areaSelect {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 2019;

  .centerBlock {
    width: 700px;
    height: 400px;
    padding: 20px;
    border-radius: 20px;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
<style>
.aaa .el-dialog__headerbtn {
  display: none;
}
</style>
